import { Dropdown, Tooltip } from 'antd';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';

import { trackRoute } from '../../analytics/mixpanel';
import ProductsOutlined from '../../assets/common/ProductsOutlined';
import { extractUrlParams } from '../../CommonFuctions/Utils';
import { PRODUCT_LINKS } from '../../config';
import { DOC_CHAT, DOC_COMPARE, SHARED } from '../../Constants/commonConstants';
import TakeTourButton from '../../Features/TakeTour/Components/TakeTourButton/TakeTourButton';
import { userDataSelector } from '../../Redux/login/loginReducer';
import { getExternalLink } from '../../utils/functions';
import { useContractSubscriptions } from '../../utils/hooks/useContractSubscriptions';
import Profile from '../Profile/Profile';
import HeaderDocChat from './HeaderDocChat';
import HeaderDocCompare from './HeaderDocCompare';
import SettingsBreadCrumb from './SettingsBreadCrumb';

function Navbar({ children, product }) {
  const location = useLocation();
  const { pathname } = location;
  const [prevLocation, updatePrevLocation] = useState('');
  const userData = useSelector(userDataSelector);
  const docChatRemainingQuota = useSelector((state) => state.docChatData?.remainingQuota);
  const docCompareRemainingQuota = useSelector((state) => state.compareData?.remainingQuota);

  useEffect(() => {
    if (pathname && prevLocation !== pathname) {
      updatePrevLocation(pathname);
      trackRoute({ route: pathname });
    }
  }, [pathname]);

  return (
    <nav className='nav'>
      <section className='nav-inner'>
        <div className='flex align-center'>
          <div className='flex align-center' style={{ gap: '12px', width: '263px' }}>
            <MyApps userData={userData} pathname={pathname} />
            <Link to={product === DOC_CHAT ? '/docchat' : '/doccompare'}>
              <h2 style={{ fontSize: '24px' }}>
                {product === DOC_CHAT ? (
                  'Mike DocChat'
                ) : (
                  <div style={{ textAlign: 'start' }}>
                    Mike
                    <br /> DocCompare
                  </div>
                )}
              </h2>
            </Link>
          </div>
          {product === DOC_CHAT && <HeaderDocChat />}
          {product === DOC_COMPARE && pathname === '/viewer' && <HeaderDocCompare />}
          {product === DOC_COMPARE && pathname.includes('/settings') && (
            <SettingsBreadCrumb product='doccompare' />
          )}
        </div>
        {children}
        <div className='flex align-center'>
          {product === DOC_COMPARE && pathname !== '/viewer' && (
            <div
              className={
                docCompareRemainingQuota === 0
                  ? 'quota-wrapper quota-error'
                  : docCompareRemainingQuota < 5
                    ? 'quota-wrapper quota-warning'
                    : 'quota-wrapper'
              }
            >
              {docCompareRemainingQuota ?? '-'} Comparisons Left
            </div>
          )}
          {extractUrlParams('type') !== SHARED &&
            (product === DOC_CHAT ? (
              <div className='flex'>
                <div
                  id='nav-docchat-quota'
                  className={
                    docChatRemainingQuota === 0
                      ? 'nav-docchat-quota nav-docchat-quota-error'
                      : docChatRemainingQuota < 5
                        ? 'nav-docchat-quota nav-docchat-quota-warning'
                        : 'nav-docchat-quota'
                  }
                >
                  {`${docChatRemainingQuota ?? '-'} Documents Left`}
                </div>
                <div className='ml-20'>
                  <TakeTourButton />
                </div>
                <Profile name={userData?.name} product={product} />
              </div>
            ) : (
              <Profile name={userData?.name} product={product} />
            ))}
        </div>
      </section>
    </nav>
  );
}
export default Navbar;

function MyApps({ userData, pathname }) {
  const contractSubscriptions = useContractSubscriptions();

  const handleProductRedirect = async (url) => {
    // Get the URL with tokens using async method
    try {
      const urlWithTokens = await getExternalLink(url);
      // replace won't add history entry and back button work
      window.location.replace(urlWithTokens);
    } catch (error) {
      console.error('Error redirecting to product:', error);
      // Fallback to redirect without tokens
      window.location.replace(url);
    }
  };

  function popupRender() {
    return (
      <section className='products-popup-section'>
        <h2 className='mb-16 color-primary'>My Account</h2>
        <button className='product' onClick={() => handleProductRedirect(PRODUCT_LINKS.ACCOUNT)}>
          Mike Account
        </button>
        <h2 className='mt-24 mb-16 color-primary'>Contract Solutions</h2>
        <div className='flex' style={{ gap: '12px' }}>
          <Tooltip
            title={!contractSubscriptions.clm ? 'Please contact our team to get access.' : null}
            placement='right'
          >
            <button
              className='product'
              disabled={!contractSubscriptions.clm}
              onClick={() => handleProductRedirect(PRODUCT_LINKS.CLM)}
            >
              Mike CLM
            </button>
          </Tooltip>
          {!(pathname === '/doccompare' || pathname === '/viewer') && (
            <Tooltip
              title={
                !contractSubscriptions.docCompare ? 'Please contact our team to get access.' : null
              }
              placement='right'
            >
              <button
                className='product'
                disabled={!contractSubscriptions.docCompare}
                onClick={() => handleProductRedirect(PRODUCT_LINKS.DOC_COMPARE)}
              >
                Doc Compare
              </button>
            </Tooltip>
          )}
          {!(pathname === '/docchat' || pathname === '/viewer-docchat') && (
            <Tooltip
              title={
                !contractSubscriptions.docChat ? 'Please contact our team to get access.' : null
              }
              placement='right'
            >
              <button
                className='product'
                disabled={!contractSubscriptions.docChat}
                onClick={() => handleProductRedirect(PRODUCT_LINKS.DOC_CHAT)}
              >
                Doc Chat
              </button>
            </Tooltip>
          )}
        </div>
        <h2 className='mt-24 mb-16 color-primary'>Litigation Solutions</h2>
        <Tooltip
          title={
            !userData?.organisation?.organisationSubscription?.litigator
              ? 'Please contact our team to get access.'
              : null
          }
          placement='right'
        >
          <button
            className='product'
            onClick={() => handleProductRedirect(PRODUCT_LINKS.LITIGATOR)}
            disabled={!userData?.organisation?.organisationSubscription?.litigator}
          >
            Mike Litigator
          </button>
        </Tooltip>
      </section>
    );
  }
  return (
    <Dropdown trigger={['hover']} popupRender={popupRender} destroyOnHidden>
      <span className='flex'>
        <ProductsOutlined />
      </span>
    </Dropdown>
  );
}
